import { FC } from 'react';
import styled from '@emotion/styled';

interface BrandLiabilityCompensationBannerProps {
  parallel_imported_banner_image_url: string;
}

export const BrandLiabilityCompensationBanner: FC<React.PropsWithChildren<BrandLiabilityCompensationBannerProps>> = ({
  parallel_imported_banner_image_url,
}) => {
  return (
    <Wrapper>
      <Wrap>
        <Image src={parallel_imported_banner_image_url} alt='liability-compensation-banner' />
      </Wrap>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 24px 0;
`;

const Wrap = styled.div`
  padding: 0 16px;
`;

const Image = styled.img`
  width: 100%;
  object-fit: fill;
`;
